<template lang="html">
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h1 class="title">Small</h1>
          <figure class="image is-4by3">
            <img class="zoom-default" src="static/images/small/small-pääkuva-uusi.jpg">
          </figure>
        </div>
        <div class="column is-6" style="margin-top: 55px;">
          <div class="content">
            <p class="title">
              Small chair is a dining chair made of rattan that combines modern simple aesthetics with rounded shapes that are characteristic to the material.
            </p>
            <p>“Rattan is a very unique material because of its flexibility and strength and in our design we wanted to exploit these qualities to make a light but still strong construction.”</p>
            <p>
              The chair is an outcome of a rattan furniture course in Fall 2015 and it’s a teamwork between two designers Jeanett Hardon and Aino Michelsen. The course was part of the master studies at KADK in Copenhagen.
            </p>
            <p>“We worked on the design, mockups and material testings for 5 weeks in Denmark and after that the final prototype building took place in Indonesia.”</p>
            <br>
            <p>Photography: KADK/Aino Michelsen</p>
          </div>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img class="zoom-default" data-zoom-src="static/images/small/small_02-highres.jpg" src="static/images/small/small_02.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img class="zoom-default" data-zoom-src="static/images/small/small_03-highres.jpg" src="static/images/small/small_03.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img class="zoom-default" data-zoom-src="static/images/small/small_04-highres.jpg" src="static/images/small/small_04.jpg">
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import mediumZoom from 'medium-zoom'

export default {
  mounted () {
    mediumZoom('.zoom-default', {
      container: {
        top: 50
      }
    })
  }
}

</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/portfolio/work/Small.vue